import { useMarketAccountsContext, type Allocation } from '@talos/kyoko';
import { useMemo } from 'react';
import { usePermittedMarketAccountsSet } from '../../../hooks';
import { useSubAccounts } from '../../../providers';
import { useTradingControlsAccountSegregationBypass } from './useTradingControlsAccountSegregationBypass';

/**
 * This function returns all tradable market account names that the user has access to
 */
export function useAllTradableMarketAccountNames(): string[] {
  const { marketAccountsList } = useMarketAccountsContext();
  const { tradableSubAccounts } = useSubAccounts();
  const bypassAccountSegregation = useTradingControlsAccountSegregationBypass();

  const subAccountAllocations = useMemo<Allocation[] | -1>((): Allocation[] | -1 => {
    if (bypassAccountSegregation) {
      return -1;
    }
    const allocations = tradableSubAccounts?.map(sa => ({
      subAccount: sa.Name,
      value: '',
    }));
    return allocations?.[0] ? allocations : [{ subAccount: '', value: '100' }];
  }, [tradableSubAccounts, bypassAccountSegregation]);

  const permittedMarketAccountsSet = usePermittedMarketAccountsSet({
    subAccountAllocations,
    combineAllMarketAccounts: true,
  });

  return useMemo(() => {
    if (permittedMarketAccountsSet === null) {
      return marketAccountsList.map(m => m.Name);
    } else {
      return Array.from(permittedMarketAccountsSet);
    }
  }, [permittedMarketAccountsSet, marketAccountsList]);
}
